/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OvenCapacityDto } from '../models/OvenCapacityDto';
import type { ResourceDto } from '../models/ResourceDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ResourceControllerService {
    /**
     * @param uuid
     * @returns ResourceDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ResourceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ResourceDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ResourceDto,
    ): CancelablePromise<ResourceDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/resources/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/resources/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ResourceDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ResourceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources',
        });
    }
    /**
     * @param requestBody
     * @returns ResourceDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ResourceDto,
    ): CancelablePromise<ResourceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/resources',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param materialId
     * @returns OvenCapacityDto OK
     * @throws ApiError
     */
    public static getOvenCapacity(
        materialId: string,
    ): CancelablePromise<OvenCapacityDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/ovenCapacity',
            query: {
                'materialId': materialId,
            },
        });
    }
}
